import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FOOTER } from "@/constants/testIds";

export default function Footer() {
  const { pathname } = useLocation();
  const onHome = pathname === "/";
  const sectionHref = (id) => (onHome ? `#${id}` : `/#${id}`);

  return (
    <footer
      data-testid={FOOTER.section}
      className="relative border-t border-white/5 pt-12 md:pt-16 pb-8 md:pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 md:px-10">
        <div className="flex items-start justify-between flex-wrap gap-8 md:gap-10">
          <div>
            <div className="inline-flex items-baseline gap-[3px]">
              <span className="font-display text-[22px] font-black tracking-[-0.04em] text-white leading-none">JD</span>
              <span className="font-display text-[22px] font-light tracking-[0.32em] text-white/85 leading-none uppercase">tech</span>
              <span className="ml-1 h-1.5 w-1.5 rounded-full bg-[#0A84FF] shadow-[0_0_12px_rgba(10,132,255,0.9)]" />
            </div>
            <p className="mt-3 md:mt-4 font-display text-xl sm:text-2xl md:text-3xl font-bold tracking-tight max-w-md text-grad">
              Engineered for the future. Trusted by the present.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-10 md:gap-16 text-sm">
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#6b6b70] mb-3">Sitemap</div>
              <ul className="space-y-2">
                <li><a href={sectionHref("services")} className="text-white/70 hover:text-white transition-colors">Services</a></li>
                <li><a href={sectionHref("work")} className="text-white/70 hover:text-white transition-colors">Work</a></li>
                <li><a href={sectionHref("process")} className="text-white/70 hover:text-white transition-colors">Process</a></li>
                <li><a href={sectionHref("contact")} className="text-white/70 hover:text-white transition-colors">Contact</a></li>
              </ul>
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#6b6b70] mb-3">Touch</div>
              <ul className="space-y-2">
                <li>
                  <a
                    href="mailto:contact@jdtechnologies.co"
                    data-testid={FOOTER.emailLink}
                    className="text-white/70 hover:text-white transition-colors"
                  >
                    contact@jdtechnologies.co
                  </a>
                </li>
                <li><span className="text-white/70">jdtechnologies.co</span></li>
                <li>
                  <Link
                    to="/privacy"
                    className="text-white/70 hover:text-white transition-colors"
                  >
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer bottom strip */}
        <div className="mt-16 pt-6 border-t border-white/5 flex flex-wrap items-center justify-between gap-3">
          <Link
            to="/privacy"
            className="text-[11px] text-[#6b6b70] hover:text-white/80 tracking-wide transition-colors"
          >
            Privacy Policy
          </Link>
          <p className="text-[11px] text-[#6b6b70] tracking-wide">
            © {new Date().getFullYear()} JDTECH. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
